export default __webpack_public_path__ + "static/media/digest.ab194a1b.svg";